<template>
  <div class="items">
    <div class="close" @click="deletePlanStep(index)"></div>
    <div class="cd top">
      <!-- <div class="no">{{$pstore.state.finaldata[$pstore.state.currentindex].stepindex+1}}</div> -->
      <div class="no">{{index+1}}</div>
      <div class="time">
        <span>{{$t('schedule.palyTime')}}</span>
        <div class="tt">
          <!-- <el-time-picker is-range v-model="plantime" range-separator="至" start-placeholder="开始时间"
						:clearable="false" end-placeholder="结束时间" placeholder="选择时间范围" @change="saveTime(index)"
						value-format="HH:mm:ss">
					</el-time-picker> -->
          <el-time-picker v-model="planStarttime" :placeholder="$t('schedule.selectStartTime')" value-format="HH:mm:ss" @change="changeStartTime(index)">
          </el-time-picker>
          <span style="margin-left: 10px;margin-right: 10px;">-</span>
          <el-time-picker v-model="planEndtime" :placeholder="$t('schedule.selectEndTime')" value-format="HH:mm:ss" @change="changeEndTime(index)">
          </el-time-picker>
        </div>
      </div>
    </div>
    <div class="cd count">
      <span class="count-label">{{$t('schedule.conserLoop')}}</span>
      <div>
        <!-- <el-input :value="countvalue1" @blur="saveCount(index)"></el-input> -->
        <el-input v-model="count" @blur="saveCount(index)" key="count" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
      </div>
      <span class="count-label">{{$t('cscit1')}}</span>
      <div>
        <el-input v-model="allNumber" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
      </div>
    </div>
    <div class="cd date">
      <div class="cbox">
        <el-checkbox v-model="isDateLimit"><span>{{$t('schedule.validDate')}}</span></el-checkbox>
      </div>

      <div class="block cdate">
        <span class="dates">{{$t('schedule.date')}}</span>
        <!-- <el-date-picker v-model="plandate" type="daterange" range-separator="至" start-placeholder="开始日期"
					:clearable="false" end-placeholder="结束日期" :disabled="!this.isDateLimit" @change="saveDate(index)"
					value-format="yyyy/MM/dd">
				</el-date-picker> -->
        <el-date-picker v-model="planStartdate" type="date" :disabled="!this.isDateLimit" @change="changeStartDate(index)" value-format="yyyy-MM-dd" style="width: 160px;">
        </el-date-picker>
        <span style="margin-left: 10px;margin-right: 10px;">-</span>
        <el-date-picker v-model="planEnddate" type="date" :disabled="!this.isDateLimit" @change="changeEndDate(index)" value-format="yyyy-MM-dd" style="width: 160px;">
        </el-date-picker>

      </div>
    </div>
    <div class="cd week">
      <ul class="weeks">
        <li :class="{active:$pstore.state.finaldata[$pstore.state.currentindex].step[this.index].panduan.length==7}" @click="change_allactive"><span>{{$t('schedule.daily')}}</span></li>
        <li v-for="(item,weeksindex) in weeks" :key="weeksindex" @click="selectWeek(weeksindex)" :class="{active:item.value==1}"><span>{{$t(item.name)}}</span></li>
      </ul>
    </div>
  </div>
</template>

<script>
import superClone from '@/assets/scripts/superClone.js';
const newDate = new Date();
export default {
  name: "TimePlanItems",
  props: {
    index: {
      type: Number
    }
  },
  data() {
    return {
      countvalue: this.countvalue1,
      stardate: this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].dateStart,
      finishdate: this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].dateEnd,
      beijinTime: newDate,
      allactive: false,
    }
  },
  methods: {
    //点击每日
    change_allactive() {
      this.$pstore.commit('change_allactive', this.index)
    },
    selectWeek(weeksindex) {
      this.$pstore.commit('selectWeek', [weeksindex, this.index])
      if (this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].validWeek[
        weeksindex
      ].value == 1) {
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].panduan.push(this
          .$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].validWeek[
          weeksindex
        ])
      } else {
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].panduan.pop()
      }
    },
    addPlanStep() {
      this.$pstore.commit('addPlanStep')
    },
    //保存播放时间
    // saveTime(index) {
    // 	this.$pstore.commit('saveTimePlanTime', [index, this.plantime])
    // },
    changeStartTime(index) {
      if (this.planStarttime > this.planEndtime) {
        this.$msg({
          message: this.$t('schedule.startTimeTips'),
          type: 'warning'
        });
        this.planStarttime = '00:00:00'
      } else {
        this.$pstore.commit('changeStartTime', [index, this.planStarttime])
      }

    },
    changeEndTime(index) {
      if (this.planEndtime < this.planStarttime) {
        this.$msg({
          message: this.$t('schedule.endTimeTips'),
          type: 'warning'
        });
        this.planEndtime = '23:59:59'
      } else {
        this.$pstore.commit('changeEndTime', [index, this.planEndtime])
      }

    },
    saveDate(index) {
      let nowDate = new Date()
      let year = nowDate.getFullYear()
      let month = nowDate.getMonth() + 1
      let day = nowDate.getDate()
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      const nowDates = year + "/" + month + "/" + day;
      console.log("开始日期是.....", this.plandate[0])
      if (this.plandate[0] < nowDates) {
        alert(this.$t('cscit3'))
      } else {
        this.$pstore.commit('saveTimePlanDate', [index, this.plandate])
      }

    },
    changeStartDate(index) {
      console.log('start', this.planStartdate)
      console.log('end', this.planEnddate)
      if (this.planStartdate > this.planEnddate) {
        console.log('???')
        this.$msg({
          message: this.$t('schedule.startDateTips'),
          type: 'warning'
        });
        this.planStartdate = new Date();
      } else {
        console.log('!!!')
        this.$pstore.commit('changeStartDate', [index, this.planStartdate])
      }
    },
    changeEndDate(index) {

      if (this.planEnddate < this.planStartdate) {
        this.$msg({
          message: this.$t('schedule.endDateTips'),
          type: 'warning'
        });
        this.planEnddate = new Date();
      } else {
        this.$pstore.commit('changeEndDate', [index, this.planEnddate])
      }

    },
    //保存播放次数
    saveCount(index) {
      this.$forceUpdate();
      //console.log("出发blur时index----->",index)
      this.$pstore.commit('saveTimePlanCount', [index, this.count])
    },
    //删除计划步骤
    deletePlanStep(index) {
      if (this.$pstore.state.finaldata[this.$pstore.state.currentindex].step.length === 1) {
        this.$msg({
          showClose: true,
          message: this.$t('schedule.saveAplan'),
          type: 'warning'
        });
      } else {
        this.$pstore.commit('deletePlanStep', index)
      }

    },
    publish() {
      this.$pstore.commit('publish');
    }
  },
  computed: {
    count: {
      get() {
        return this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].playCount
      },
      set(v) {
        // this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = JSON.parse(JSON.stringify(this
        //   .$pstore.state.finaldata[this.$pstore.state
        //     .currentindex].step)) // eslint-disable-line no-unused-vars
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = superClone(this
          .$pstore.state.finaldata[this.$pstore.state
            .currentindex].step); // eslint-disable-line no-unused-vars
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].playCount = v
      }
    },
    allNumber: {
      get() {
        return this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].allNumber
      },
      set(v) {
        // this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = JSON.parse(JSON.stringify(this
        //   .$pstore.state.finaldata[this.$pstore.state
        //     .currentindex].step)) // eslint-disable-line no-unused-vars
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = superClone(this
          .$pstore.state.finaldata[this.$pstore.state
            .currentindex].step);// eslint-disable-line no-unused-vars
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].allNumber = v
      }
    },
    // plantime: {
    // 	get() {
    // 		return [this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].startTime,
    // 			this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].endTime
    // 		]
    // 	},
    // 	set(v) {
    // 		this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = JSON.parse(JSON.stringify(this
    // 			.$pstore.state.finaldata[this.$pstore.state
    // 				.currentindex].step))
    // 		this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].startTime = v[0]
    // 		this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].endTime = v[1]
    // 	}
    // },
    planStarttime: {
      get() {
        return this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].startTime
      },
      set(v) {
        // this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = JSON.parse(JSON.stringify(this
        //   .$pstore.state.finaldata[this.$pstore.state
        //     .currentindex].step))
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = superClone(this
          .$pstore.state.finaldata[this.$pstore.state
            .currentindex].step);
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].startTime = v;
      }
    },
    planEndtime: {
      get() {
        return this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].endTime
      },
      set(v) {
        // this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = JSON.parse(JSON.stringify(this
        //   .$pstore.state.finaldata[this.$pstore.state
        //     .currentindex].step))
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = superClone(this
          .$pstore.state.finaldata[this.$pstore.state
            .currentindex].step);
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].endTime = v;
      }
    },
    isDateLimit: {
      get() {
        return this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].isDateLimit
      },
      set(v) {
        // this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = JSON.parse(JSON.stringify(this
        //   .$pstore.state.finaldata[this.$pstore.state
        //     .currentindex].step))
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = superClone(this
          .$pstore.state.finaldata[this.$pstore.state
            .currentindex].step);
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].isDateLimit = v
      }
    },
    // plandate: {
    // 	get() {
    // 		return [this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].dateStart,
    // 			this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].dateEnd
    // 		]

    // 	},
    // 	set(v) {
    // 		this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = JSON.parse(JSON.stringify(this
    // 			.$pstore.state.finaldata[this.$pstore.state
    // 				.currentindex].step))
    // 		this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].dateStart = v[0]
    // 		this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].dateEnd = v[1]
    // 	}
    // },
    planStartdate: {
      get() {
        return this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index]
          .dateStart

      },
      set(v) {
        // this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = JSON.parse(JSON.stringify(
        //   this.$pstore.state.finaldata[this.$pstore.state.currentindex].step))
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = superClone(
          this.$pstore.state.finaldata[this.$pstore.state.currentindex].step);
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].dateStart = v
      }
    },
    planEnddate: {
      get() {
        return this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index]
          .dateEnd

      },
      set(v) {
        // this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = JSON.parse(JSON.stringify(
        //   this.$pstore.state.finaldata[this.$pstore.state.currentindex].step))
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step = superClone(
          this.$pstore.state.finaldata[this.$pstore.state.currentindex].step);
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].dateEnd = v
      }
    },
    weeks: {
      get() {
        return this.$pstore.state.finaldata[this.$pstore.state.currentindex].step[this.index].validWeek
      },
      set(v) {
        console.log("触发......")
        console.log("v-----", v)
      }
    },
  }

}
</script>

<style lang="scss" scoped>
.el-input__inner {
  border-radius: 40px;
}

.cd /deep/ .el-input__inner {
  border-radius: 40px;
  width: 180px;
}

.active {
  background-color: #35cafa;
}

span {
  font-family: PingFang-SC-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3px;
  color: #617883;
}

.close {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(38%, -33%);
  background-image: url(~@/assets/images/public/public_close.png);
  background-size: 100%;
  background-position: center;
  cursor: pointer;
}

.timeplan {
  width: 100%;
  height: 100%;
  background-color: white;
}

.titd {
  height: 5%;
  border-bottom: 1px solid dimgray;
}

.titd::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.tit {
  font-family: PingFang-SC-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3px;
  height: 16px;
  letter-spacing: 3px;
  color: #617883;
  padding-left: 2%;
}

.no {
  width: 40px;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  background-image: linear-gradient(
      270deg,
      #86eae7 0%,
      #4cccf0 45%,
      #11adf8 100%
    ),
    linear-gradient(#35cafa, #35cafa);
  background-blend-mode: normal, normal;
  border-radius: 0px 20px 20px 0px;
  text-align: center;
  color: #ffffff;
}

.time {
  display: flex;
  align-items: center;
  padding-left: 1%;
}

.time span {
  display: block;
}

.tt {
  width: 75%;
  display: flex;
  padding-left: 2%;
  align-items: center;
}

.time el-input {
  width: 20%;
}

.items {
  width: 95%;
  height: 36%;
  min-height: 185px;
  margin: 1% auto;
  border: 1px solid #cfd5d8;
  display: flex;
  border-radius: 15px;
  flex-direction: column;
  position: relative;
  /* border: 1px solid black; */
}

.cd {
  flex-basis: 25%;
  box-sizing: border-box;
  /* border: 1px solid black; */
}

.top {
  display: flex;
  align-items: center;
}

.time {
  flex-basis: 51%;
}

.count {
  display: flex;
  align-items: center;
  .count-label {
    width: 120px;
  }
}

.count span {
  margin-left: 1%;
}

.count div {
  flex-basis: 38%;
  margin-left: 1%;
}

.count el-col {
  padding-left: 1%;
}

.date {
  display: flex;
  align-items: center;
}

.cbox {
  flex-basis: 15%;
  margin-left: 1%;
}

/* .cbox>>>.el-checkbox__inner{
		background-color: #35cafa;
		border: none;
	} */
/deep/.is-checked .el-checkbox__inner {
  background-color: #35cafa !important;
  border: 1px solid #35cafa !important;
}

/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #35cafa !important;
}

/deep/.el-checkbox__inner:hover {
  border-color: #35cafa;
}

.cdate {
  .dates {
    min-width: 40px;
  }
  flex-basis: 60%;
  display: flex;
  align-items: center;
}

.week {
  display: flex;
  width: 100%;
  align-items: center;
}

.weeks {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.weeks li {
  display: block;
  margin: 8px;
  padding: 1%;
  border-radius: 4px;
  border: solid 1px #cfd5d8;
}

.weeks li:hover {
  cursor: pointer;
}

.addplan {
  border-radius: 20px;
  border: solid 1px #cfd5d8;
  width: 95%;
  height: 13%;
  margin: 1% auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  font-family: PingFang-SC-Regular;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0px;
  color: var(--theme-color-customized-1);
}

.button {
  margin: 0 auto;
  width: 66%;
  height: 8%;
  display: flex;
  justify-content: space-between;
}

.control {
  width: 30%;
  text-align: center;
  align-items: center;
  border-radius: 40px;
}

.control::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.fabu {
  background-image: linear-gradient(
      270deg,
      #86eae7 0%,
      #4cccf0 45%,
      #11adf8 100%
    ),
    linear-gradient(#dddddd, #dddddd);
  background-blend-mode: normal, normal;
  border-radius: 40px;
  font-family: PingFang-SC-Regular;
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 38px;
  letter-spacing: 0px;
  color: #ffffff;
}

.white {
  border-radius: 40px;
  border-style: solid;
  font-size: 26px;
  border-width: 1px;
  font-family: PingFang-SC-Regular;
  border-image-slice: 1;
  color: var(--theme-color-customized-1);
}
</style>
